(() => {
  if (window.__gustaCartStatusLabelsInitialized) return;
  window.__gustaCartStatusLabelsInitialized = true;

  const selector = [
    '.mini-cart__property.gusta-pickup-only__line-status',
    '.mini-cart__property.gusta-preorder__line-status',
    '.line-item__property.gusta-pickup-only__line-status',
    '.line-item__property.gusta-preorder__line-status'
  ].join(',');

  const getStatusCopy = () => {
    const source = document.querySelector('[data-gusta-cart-status-copy]');

    if (!source) return {};

    try {
      return JSON.parse(source.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const updateStatusLabels = () => {
    const statusCopy = getStatusCopy();

    document.querySelectorAll(selector).forEach((element) => {
      const statusElement = element.querySelector('[data-gusta-cart-status]') || element;
      const text = statusElement.textContent.trim();
      const separatorIndex = text.indexOf(':');
      const status = separatorIndex === -1 ? text : text.slice(separatorIndex + 1).trim();
      const displayText = statusCopy[status] || status;

      if (displayText && displayText !== text) {
        statusElement.textContent = displayText;
      }
    });
  };

  let updateQueued = false;

  const scheduleStatusLabelUpdate = () => {
    if (updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateStatusLabels();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStatusLabelUpdate, { once: true });
  } else {
    scheduleStatusLabelUpdate();
  }

  new MutationObserver(scheduleStatusLabelUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
